import "./styles/fixed-navigation.css";
import "./styles/contained-controls.css";
import "../../shared/academy-brand.css";
import React from "react";
import ChatonerAIOrganizationSystem from "./App";
import { mountFrontend } from "./app/bootstrap";
import { APP_ID } from "./config/environment";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

const root = document.getElementById("root");
if (!root) throw new Error("Chatoner AI Academy Organization root element was not found.");
void mountFrontend(
  root,
  <React.StrictMode>
    <AppErrorBoundary>
      <ChatonerAIOrganizationSystem />
    </AppErrorBoundary>
  </React.StrictMode>,
  APP_ID,
);
